import $ from 'jquery'; 
window.$ = window.jQuery = $;
import introJs from 'intro.js/intro.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
window.introJs = introJs;
import 'bootstrap';
import 'slick-carousel';
import './inventor/workstream';
import './premium-vendor/text-editor/custom';
import './premium-vendor/text-editor/jquery.sticky';
//import './premium-vendor/text-editor/main'
import './premium-vendor/text-editor/title';
import './premium-vendor/datafilter';
import './premium-vendor/quote';
import '@stripe/stripe-js';
//import './premium-vendor/stripedata';
import './inventor/account';
import {GoogleCharts} from 'google-charts';
import './inventor/chart';
import './components/sign-up';
import './premium-vendor/load-more';
import './account/subscription';
import './components/showcase';
import './components/filter';
import './components/delete';
import './components/blog-filter';
//slick slider initialization
import '../js/slick-slider-init.js';
// ninja slider
import '../js/ninja-slider.js';
// signup step form
import '../js/signup-step.js';
// filter initializations
import '../js/filter.js';
// Showmore text initializations
import '../js/showmore.js';
// select 2 sources
import '../js/select2.min.js';
// select 2 initializations
import '../js/autoload.js';

// admin scripts
import '../js/admin/theme.js';
import '../js/admin/chartjs.js';
import '../js/admin/feather.js';
import '../js/admin/flatpickr.js';
import '../js/admin/data-table.js';
import '../js/admin/sidebar.js';
import '../js/admin/admin-main.js';
import '../js/admin/review-data.js';
const CryptoJS = require('crypto-js');
export function ninjaKey() 
{
    const ninjaSliderKey = $("#envSliderKey").val();
    return ninjaSliderKey;
}
export function stripeKeyData() 
{
    const parts = $('#baseKey').val().split(":");
    var stripeEncryptedKey = $("#stripeEnv").val();
    var encryptionKey = parts[1];
    stripeEncryptedKey = atob(stripeEncryptedKey);
    stripeEncryptedKey = JSON.parse(stripeEncryptedKey);
    const iv = CryptoJS.enc.Base64.parse(stripeEncryptedKey.iv);
    const value = stripeEncryptedKey.value;
    encryptionKey = CryptoJS.enc.Base64.parse(encryptionKey);
    var stripeKeyValue = CryptoJS.AES.decrypt(value, encryptionKey, {
      iv: iv
    });
    stripeKeyValue = stripeKeyValue.toString(CryptoJS.enc.Utf8);
    var match = stripeKeyValue.match(/"([^"]+)"/);
    var apiKey = match ? match[1] : null;
    return apiKey;
}
export function getCuuidUrl()
{
    let cuuid = new URLSearchParams(new URL(window.location.href).search).get("cuuid");
    return cuuid;
}
export function regionSession(country, category, state = [], city = [])
{
    $.ajax(
    {
        url: '/region/session', 
        method: 'POST',
        data:   { 
                    "_token": $("input[name='_token']").val(),
                    "country": country,
                    "category": category,
                    "state": state,
                    "city": city,
                }, 
        success: function(response) 
        {
        }
    });
}